import React, { JSXElementConstructor, ReactElement } from "react";
import { NoDataComponent } from "../../../../../ds";
import { SubscriptionChosen } from "../../../../payment/business";
import { SubscriptionPlans } from "../../api";
import { SubscriptionDataResponse, SubscriptionPageFactory, SubscriptionStatementSignedPlan } from "../../interfaces";

export class SubscriptionPageFactoryImpl implements SubscriptionPageFactory {
    create(
        subscriptionData: SubscriptionDataResponse | undefined,
        signedPlan?: SubscriptionStatementSignedPlan,
        handlerShowModalPayment?: (data: SubscriptionChosen) => void
    ): ReactElement<any, string | JSXElementConstructor<any>> {
        if (!subscriptionData?.success) return <NoDataComponent />;
        return <SubscriptionPlans plans={subscriptionData.response} signedPlan={signedPlan} handlerShowModalPayment={handlerShowModalPayment} />
    }
}